<template>
  <div class="p-6 loading-table" v-if="loading">
    <spinner-color />
  </div>
  <div v-else>
    <data-table-order
      :data="this.$store.state.dataList.orders"
      :statusForAdvancedSearch="statusForAdvancedSearch"
      :header="header"
      :body="body"
      :pageName="pageName"
      :titlePage="titlePage"
      :advancedSearchData="advancedSearchData"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataTableOrder from "../components/table-components/DataTableOrder.vue";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import loadingTable from "@/mixins/loadingTable.js";
import allStatus from "@/views/status/orderStatus";

export default {
  mixins: [loadingTable],
  components: {
    DataTableOrder,
    SpinnerColor,
  },
  data() {
    return {
      header: [
        { header: "sentDate", key: "sent_at" },
        { header: "theDateOfDelivery", key: "due_date" },
        { header: "code", key: "code" },
        { header: "sender", key: "second_client" },
        { header: "receiver", key: "receiver" },
        { header: "government", key: "gov_name" },
        { header: "area", key: "area" },
        { header: "collectedAmount", key: "amount" },
        { header: "branch", key: "branch_name" },
      ],
      body: [
        "sent_at",
        "due_date",
        "code",
        "second_client",
        "receiver",
        "gov_name",
        "area",
        "amount",
        "branch_name",
      ],
      advancedSearchData: [
        {
          label: "sentDate",
          nameToEndpoint: "sentDate",
          max: "",
          type: "date",
        },
        {
          label: "theDateOfDelivery",
          nameToEndpoint: "theDateOfDelivery",
          max: "",
          type: "date",
        },
        { label: "code", nameToEndpoint: "code", max: "", type: "text" },
        { label: "sender", nameToEndpoint: "sender", max: 15, type: "text" },
        {
          label: "receiver",
          nameToEndpoint: "receiver",
          max: 15,
          type: "text",
        },
        { label: "area", nameToEndpoint: "area", max: 13, type: "text" },
        {
          label: "collectedAmount",
          nameToEndpoint: "collectedAmount",
          max: 15,
          type: "text",
        },
      ],
      statusForAdvancedSearch: allStatus.underway,
      pageName: "order/assigned-with-captain",
      titlePage: "assigned",
    };
  },
  methods: {
    ...mapActions("dataList", ["fetchDataListItems"]),
  },
  async created() {
    this.credentials.page = "order/assigned-with-captain";
    this.fetchData(this.credentials);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";
</style>
